import React from "react";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import ContactSection from "./components/ContactSection";
import ExternalScripts from "../../common/ExternalScripts";

const Contact = () => {
  return (
    <div>
      <div className='boxcar-wrapper' style={{backgroundColor:"#050B20"}} >
       <div style={{paddingBottom:"220px"}} >
      <Header preclass="normal"  />
      </div>
      <ExternalScripts/>

      <ContactSection />
      <Footer />
      </div>
    </div>
  );
};

export default Contact;
